import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://e72472da6c217ba6b9874d46c800d582@sentry.ops.viory.team//4',
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
